<!--
 * Path: src/features/browser/forms/color/ColorEdit.vue
 * Task: Editable color field with an integrated Vuetify color picker inside a dropdown.
 * Update: Removed the separate avatar box. The button itself acts as the color preview.
-->
<template>
  <div class="d-flex align-center mt-1">
    <!-- Button opens picker and shows current color as its background -->
    <v-menu :close-on-content-click="false" location="bottom start">
      <template v-slot:activator="{ props }">
        <v-btn
          v-bind="props"
          :color="modelValue || defaultColor"
          variant="flat"
          class="me-3 elevation-1 text-none font-weight-medium"
          size="small"
          style="border: 1px solid rgba(128,128,128,0.2);"
        >
          Select Color
        </v-btn>
      </template>
      <v-card class="pa-2 bg-surface">
        <v-color-picker v-model="modelValue" :modes="['hex']" hide-inputs flat elevation="0"></v-color-picker>
      </v-card>
    </v-menu>

    <!-- Input field for manual hex entry, label removed as FormBlockWrapper handles it -->
    <v-text-field
      v-model="modelValue"
      variant="outlined"
      density="compact"
      hide-details
      class="flex-grow-1 font-family-mono"
      placeholder="#XXXXXX"
    ></v-text-field>
  </div>
</template>

<script setup lang="ts">
interface Props {
  defaultColor?: string;
}

withDefaults(defineProps<Props>(), {
  defaultColor: 'grey'
});

const modelValue = defineModel<string>({ default: '' });
</script>

<style scoped>
.font-family-mono {
  font-family: monospace;
}
</style>
